enum SolicitacaoAcoesBackofficeEnum {
  Visualizar = 'visualizar',
  AgendamentoRealizaTriagem = 'agendamentoRealizaTriagem',
  AutorizacaoFazAnalisePreAutorizacao = 'autorizacaoFazAnalisePreAutorizacao',
  AutorizacaoFazAnalisePreCotacao = 'autorizacaoFazAnalisePreCotacao',
  AutorizacaoFazRetornoParaCotacao = 'autorizacaoFazRetornoParaCotacao',
  AutorizacaoEnviaParaRetornoDeCotacao = 'autorizacaoEnviaParaRetornoDeCotacao',
  AutorizacaoAutorizar = 'autorizacaoAutorizar',
  AutorizacaoAutorizaNegociacaoParticular = 'autorizacaoAutorizaNegociacaoParticular',
  AutorizacaoFazCotacao = 'autorizacaoFazCotacao',
  AutorizacaoFazAnalisePosCotacao = 'autorizacaoFazAnalisePosCotacao',
  AutorizacaoEmAnalise = 'autorizacaoEmAnalise',
  SuprimentosFazCotacao = 'suprimentosFazCotacao',
  SuprimentosAtualizaPrecificacaoOperadora = 'suprimentosAtualizaPrecificacaoOperadora',
  AutorizacaoResolvePendenciaRoboAutorizacao = 'autorizacaoResolvePendenciaRoboAutorizacao',
  AutorizacaoEvoluiAguardandoPrazoPosTriagem = 'autorizacaoEvoluiAguardandoPrazoPosTriagem',
  AutorizacaoResolveErroIntegracaoOperadora = 'autorizacaoResolveErroIntegracaoOperadora',
}

export default SolicitacaoAcoesBackofficeEnum
